module.exports = __webpack_public_path__ + "static/img/logo6.1dbd654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo6.jpg
// module id = eLF1
// module chunks = 2